<template>
  <div class="toast" :class="[type, visible ? 'show' : 'hide']">
    <div class="content" @mouseenter="mouseIn = true" @mouseleave="checkLeave">
      {{ msg }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    this.timer = null;
    this.cancel = () => {};
    return {
      msg: '',
      type: '',
      visible: false,
      duration: 0,
      timestamp: 0,
      mouseIn: false,
    };
  },
  methods: {
    show(msg, type, duration = 3000) {
      this.msg = msg;
      this.type = type;
      this.duration = duration;
      this.timestamp = +new Date();
      this.visible = true;
      clearTimeout(this.timer);
      this.cancel();
      return new Promise((r) => {
        this.cancel = r;
        this.timer = setTimeout(() => {
          r();
          this.close();
        }, duration);
      });
    },
    success(msg, duration = 3000) {
      this.show(msg, 'success', duration);
    },
    warn(msg, duration = 3000) {
      this.show(msg, 'warn', duration);
    },
    error(msg, duration = 3000) {
      this.show(msg, 'error', duration);
    },
    info(msg, duration = 3000) {
      this.show(msg, 'info', duration);
    },
    close() {
      if (this.mouseIn) return;
      this.visible = false;
    },
    checkLeave() {
      if (+new Date() - this.timestamp > this.duration) {
        this.visible = false;
      }
      this.mouseIn = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 100;
  display: flex;
  justify-content: center;
  width: 100%;
  user-select: none;
  top: -100px;
  &.show {
    top: 0;
    transition: all 0.2s ease-out;
  }
  &.hide {
    top: -100px;
    transition: all 0.2s ease-in;
  }
  .content {
    display: inline-block;
    max-width: 400px;
    margin: 20px;
    background-color: #fff;
    box-shadow: 0 0 100px -60px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: lighter;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &.error .content {
    background-color: #fa5151;
    color: #fff;
  }
  &.success .content {
    background-color: #91d300;
    color: #fff;
  }
  &.warn .content {
    background-color: #ffc300;
    color: #fff;
  }
  &.info .content {
    background-color: #10aeff;
    color: #fff;
  }
}
</style>